import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

const CostCenterList = (props: PickerListProps<server.dto.CostCenter>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListCostCenterInstruction>({
    excludeKeys: [],
    page: 1,
    perPage: 20,
    visible: "onlyYes",
    keyword: ""
  });

  const setFilter = (visible: server.dto.BooleanFilterSettings) => { setInstruction(instr => ({ ...instr, visible, page: 1 })); };

  return <PickerList
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="costCenters"
    api={window.CoreApi.CostCenter.ListCostCenter}
    onClick={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={cc => cc.costCenterId}
    renderListItem={cc => <>
      <div>{cc.internalId}</div>
      <SubLabel>{cc.title}</SubLabel>
    </>}

    filter1={{
      leftButton: {
        type: "primary",
        isActive: instruction.visible === "onlyYes",
        label: RESX.SoUser.Active,
        onClick: () => { setFilter("onlyYes"); }
      },
      rightButton: {
        type: "primary",
        isActive: instruction.visible === "onlyNo",
        label: RESX.SoUser.Deactivated,
        onClick: () => { setFilter("onlyNo"); }
      }
    }}
  />;
};

export default CostCenterList;